<app-custom-table
    class="m-2 flex-1 min-h-0 overflow-auto"
    [columns]="tableColumns">
    @for (control of controls(); track control.id) {
        <tr class="!text-black">
            @for (column of tableColumns; track column) {
                <td
                    class="w-[23%]"
                    [class.!w-10]="column.key === 'required'">
                    @switch (column.key) {
                        @case ('title') {
                            {{ control.resolvedTitle ?? control.title ?? '-' }}
                        }
                        @case ('description') {
                            {{ control.resolvedDescription ?? control.description ?? '-' }}
                        }
                        @case ('type') {
                            <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                                <span class="min-w-0 break-words">
                                    {{ control.inputType | transloco }}
                                </span>

                                @if (control.isArray) {
                                    <span class="shrink-0 px-2 py-0.5 text-xs rounded bg-blue-200">
                                        {{ 'multiple' | transloco }}
                                    </span>
                                }
                            </div>
                        }
                        @case ('possibleValues') {
                            <div class="flex flex-row flex-wrap gap-2">
                                @for (value of getPossibleValues(control); track value) {
                                    <span>{{ value }}</span>
                                }
                            </div>
                        }
                        @case ('required') {
                            {{ (control.required ? 'yes' : 'no') | transloco }}
                        }
                    }
                </td>
            }
        </tr>
    }
</app-custom-table>
